import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* global docsearch */
import React, { useEffect, useRef, useState } from 'react';
import { customNavigate } from './helpers';
import { IconMagnifyingglass } from '@frameio/vapor-icons';
import useKey from 'react-use/lib/useKey';
import { buildSmartUrl } from './helpers';
import { MobileOverlay, MobileSearchWrapper, MobileContainer, MobileStyledTextField, DesktopOverlay, DesktopSearchWrapper, DesktopContainer, DesktopStyledTextField } from './styled';
import { ALGOLIA_INDEX_NAME, ALGOLIA_API_KEY, ALGOLIA_APP_ID } from '../../utils/constants';
import useScript from './useScript';

var Search = function Search(_ref) {
  var isMobile = _ref.isMobile,
      searchVisible = _ref.searchVisible,
      toggleVisible = _ref.toggleVisible;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var inputRef = useRef(null);
  var status = useScript('https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.js', 'docsearch');
  useEffect(function () {
    if (status === 'ready') {
      if (typeof docsearch !== 'undefined') {
        docsearch({
          apiKey: ALGOLIA_API_KEY,
          indexName: ALGOLIA_INDEX_NAME,
          appId: ALGOLIA_APP_ID || null,
          inputSelector: isMobile ? '#mobile-search' : '#search',
          debug: process.env.NODE_ENV != 'production' ? true : false,
          // keeps the results list open
          algoliaOptions: {
            hitsPerPage: 10
          },
          transformData: function transformData(hits) {
            var modifiedHits = hits.map(function (hit) {
              // console.log(hit);
              // Replace the URL field with the new smartPath
              var url = buildSmartUrl(hit.url); // Remove anchor if it's just gatsby-focus-wrapper

              var anchor = hit.anchor === 'gatsby-focus-wrapper' ? undefined : hit.anchor;
              return _objectSpread(_objectSpread({}, hit), {}, {
                url: url,
                anchor: anchor
              });
            });
            return modifiedHits;
          },
          handleSelected: function handleSelected(input, event, suggestion) {
            // Prevent the default behavior first
            event.preventDefault(); // Set the form value to blank

            setValue('');
            input.setVal(''); // De-focus the form field

            setFocused(false); // De-focus the form field's reference as well (vapor is sticky otherwise)

            inputRef.current.blur(); // Navigate to the new URL

            customNavigate(suggestion.url);
          }
        });
      }
    }
  }, [status]); // focus the input when the slash key is pressed

  useKey(function (event) {
    return event.key === '/' && event.target.tagName.toUpperCase() !== 'INPUT';
  }, function (event) {
    event.preventDefault();
    inputRef.current.focus();
  });

  function onChange(event) {
    setValue(event.target.value);
  }

  function onFocus() {
    document.documentElement.style.overflow = 'hidden';
    document.body.scroll = 'no';
    setFocused(true);
  }

  function onBlur() {
    document.documentElement.style.overflow = 'scroll';
    document.body.scroll = 'yes';
    setFocused(false);
    isMobile && toggleVisible(!searchVisible);
  }

  var resultsShown = focused && value.trim();
  return isMobile ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileOverlay, {
    visible: searchVisible
  }), /*#__PURE__*/React.createElement(MobileSearchWrapper, {
    visible: searchVisible
  }, /*#__PURE__*/React.createElement(MobileContainer, null, /*#__PURE__*/React.createElement(MobileStyledTextField, {
    ref: inputRef,
    type: "search",
    id: "mobile-search",
    visible: resultsShown,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange,
    value: value,
    placeholder: "Search"
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DesktopOverlay, {
    visible: resultsShown
  }), /*#__PURE__*/React.createElement(DesktopSearchWrapper, null, /*#__PURE__*/React.createElement(DesktopContainer, null, /*#__PURE__*/React.createElement(DesktopStyledTextField, {
    type: "search",
    ref: inputRef,
    id: "search",
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange,
    value: value,
    placeholder: "Search",
    adornmentAfter: /*#__PURE__*/React.createElement(IconMagnifyingglass, null)
  }))));
};

export default Search;